import {
  Card, CardContent, CircularProgress, Container, Divider,
  List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import MoneyIcon from '@material-ui/icons/Money';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import React, { useEffect, useState } from 'react';
import { PullToRefresh } from "react-js-pull-to-refresh";
import { useHistory } from 'react-router';
import MoneyDisplay from 'src/components/MoneyDisplay';
import Page from 'src/components/Page';
import { GetArtemisTodaySummary } from 'src/store/api/tasks';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  tableD: {
    maxWidth: '100%',
    tableLayout: 'fixed',
  },
  tableRow: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  contentD: {
    padding: 0
  },
  dividerD: {
    backgroundColor: '#FF9800'
  },
}));


const tahsilatDefault = {
  Adet: 0,
  Nakit: 0.00,
  KrediKarti: 0.00,
  Senet: 0.00,
  Borc: 0.00,
  Diger: 0.00,
  Toplam: 0.00,
  EkGaranti: 0.00,
  TamamlayiciUrun: 0.00,
  Odero: 0.00
}
const tahsilatlarDefault = [tahsilatDefault, tahsilatDefault];

function Tahsilat({ today }) {

  const [todosData, setTodosData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tahsilat, setTahsilat] = useState(tahsilatlarDefault);

  const history = useHistory();

  useEffect(() => {
    fetchTodos();
    // eslint-disable-next-line
  }, []);

  const onRefresh = () => {
    return new Promise((resolve) => {
      setTimeout(resolve, 50);
      fetchTodos();
    });
  }

  const fetchTodos = () => {
    setLoading(true);
    GetArtemisTodaySummary()
      .then(response => {
        // DATA KONTROLÜ: response veya response.data null ise [] ata
        let data = (response && Array.isArray(response.data)) ? response.data : [];
        
        if (data.length === 0) {
          setTahsilat(tahsilatlarDefault);
          setTodosData([]);
          setLoading(false);
          return;
        }
        let tempTahsilat = [];
        let gunler = [0, 1];
        
        gunler.forEach(gun => {
          let Adet = 0;
          let Nakit = 0.00;
          let KrediKarti = 0.00;
          let Senet = 0.00;
          let Borc = 0.00;
          let Diger = 0.00;
          let Toplam = 0.00;
          let EkGaranti = 0.00;
          let TamamlayiciUrun = 0.00;
          let Odero = 0.00;

          // SAFE FILTER & FOREACH
          data.filter(f => f && f.Bugun === gun).forEach(d => {
            Adet += 1;
            switch (d.TAHSILAT) {
              case "Nakit":
                Nakit += d.INDIRIMLI_TUTAR_KDVLI || 0;
                break;
              case "Kredi kartı":
                KrediKarti += d.INDIRIMLI_TUTAR_KDVLI || 0;
                break;
              case "Senet":
                Senet += d.INDIRIMLI_TUTAR_KDVLI || 0;
                break;
              case "Borç":
                Borc += d.INDIRIMLI_TUTAR_KDVLI || 0;
                break;
              case "Diğer":
                Diger += d.INDIRIMLI_TUTAR_KDVLI || 0;
                break;
              case "Ödero":
                Odero += d.INDIRIMLI_TUTAR_KDVLI || 0;
                break;
              default:
                break;
            }
            Toplam += d.INDIRIMLI_TUTAR_KDVLI || 0;
            if (d.Tip === 3) {
              EkGaranti += d.INDIRIMLI_TUTAR_KDVLI || 0;
            }
            if (d.Tip === 2) {
              TamamlayiciUrun += d.INDIRIMLI_TUTAR_KDVLI || 0;
            }
          });
          tempTahsilat.push({
            Adet: Adet,
            Nakit: Nakit,
            KrediKarti: KrediKarti,
            Senet: Senet,
            Borc: Borc,
            Diger: Diger,
            Toplam: Toplam,
            EkGaranti: EkGaranti,
            TamamlayiciUrun: TamamlayiciUrun,
            Odero: Odero
          });
        });
        setTahsilat(tempTahsilat.length > 0 ? tempTahsilat : tahsilatlarDefault);
        setTodosData(data);
        setLoading(false);
      }).catch(error => {
        logger.error("API Error:", error);
        setTahsilat(tahsilatlarDefault);
        setTodosData([]);
        setLoading(false);
      });
  }

  const classes = useStyles();
  
  // SAFE DATA ACCESS: tahsilat[today] undefined ise default objeyi kullan
  const currentTahsilat = (tahsilat && tahsilat[today]) ? tahsilat[today] : tahsilatDefault;

  return (
    <Page className={classes.root} title="Tahsilat Dökümü">
      <Container maxWidth="lg">
        <PullToRefresh
          pullDownContent={<CircularProgress status={'loading'} style={{ marginLeft: '44%' }} />}
          releaseContent={<CircularProgress status={'loading'} style={{ marginLeft: '44%' }} />}
          refreshContent={<CircularProgress status={'loading'} style={{ marginLeft: '44%' }} />}
          pullDownThreshold={101}
          onRefresh={onRefresh}
          triggerHeight={501}
          startInvisible={true}
        >
          <div style={{ minHeight: 400, textAlign: 'center' }}>
            <div className={clsx(classes.root, classes.todos)}>
              <Card>
                <Divider />
                {
                  loading ?
                    <CircularProgress color="primary" />
                    : <div></div>
                }
                <CardContent className={classes.contentD}>
                  <List className={classes.root}>
                    <ListItem>
                      <ListItemText 
                        primaryTypographyProps={{ variant: 'h6', component: 'div' }}
                        primary={
                          <>
                            {today === 1 ? "Bugüne" : "Düne"} randevulu <b style={{ color: '#FF0000' }}>{currentTahsilat.Adet}</b> adet ücretlendi durumuda iş emriniz bulunuyor.
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <Divider className={classes.dividerD} />
                  <List>
                    {[
                      { value: currentTahsilat.Nakit, text: 'Nakit', icon: <MoneyIcon /> },
                      { value: currentTahsilat.KrediKarti, text: 'Kredi Kartı', icon: <CreditCardIcon /> },
                      { value: currentTahsilat.Odero, text: 'Odero', icon: <CreditCardIcon /> },
                      { value: currentTahsilat.Senet, text: 'Senet', icon: <AccountBalanceWalletIcon /> },
                      { value: currentTahsilat.Borc, text: 'Borç', icon: <MoneyOffIcon /> },
                      { value: currentTahsilat.Diger, text: 'Diğer', icon: <AccountBalanceIcon /> },
                      { value: currentTahsilat.Toplam, text: 'Toplam', icon: <DoneAllIcon /> },
                    ].filter(item => item.value > 0).map((item, index) => (
                      <ListItem key={index}>
                        <ListItemIcon>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.text} primaryTypographyProps={{ component: 'span' }} />
                        <ListItemSecondaryAction>
                          {(item.value || 0).toFixed(2)} TL
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Divider className={classes.dividerD} />
                  <TableContainer component={Paper}>
                    <Table className={classes.tableD} size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">{'Müşteri'}</TableCell>
                          <TableCell>FişNo</TableCell>
                          <TableCell>Tahsilat</TableCell>
                          <TableCell align="right">Tutar(TL)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(Array.isArray(todosData) ? todosData : []).filter(d => d && d.Bugun === today).map((row, idx) => (
                          <TableRow key={row.FisNo || idx} onClick={() => history.push(`/WorkOrder/${row.FisNo}/summary`)}>
                            <TableCell component="th" scope="row" align="left">{row.Musteri}</TableCell>
                            <TableCell>{row.FisNo}</TableCell>
                            <TableCell>{(row.TAHSILAT || "").substring(0, 5)}</TableCell>
                            <TableCell align="right">{(row.INDIRIMLI_TUTAR_KDVLI || 0).toFixed(2)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <MoneyDisplay text="Toplam" value={(currentTahsilat.Toplam || 0).toFixed(2)} />
                  <Divider className={classes.dividerD} />
                  
                  {/* SAFE FILTER CHECK */}
                  {(Array.isArray(todosData) ? todosData : []).filter(d => d && d.Tip === 3 && d.Bugun === today).length > 0 &&
                    <div>
                      <TableContainer component={Paper}>
                        <Table className={classes.tableD} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Müşteri</TableCell>
                              <TableCell>FişNo</TableCell>
                              <TableCell>Tahsilat</TableCell>
                              <TableCell align="right">Tutar(TL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {todosData.filter(d => d && d.Tip === 3 && d.Bugun === today).map((row, idx) => (
                              <TableRow key={row.FisNo || idx} className={classes.tableRow} onClick={() => history.push(`/WorkOrder/${row.FisNo}/summary`)}>
                                <TableCell component="th" scope="row" align="left">{row.Musteri}</TableCell>
                                <TableCell>{row.FisNo}</TableCell>
                                <TableCell>{(row.TAHSILAT || "").substring(0, 5)}</TableCell>
                                <TableCell align="right">{(row.INDIRIMLI_TUTAR_KDVLI || 0).toFixed(2)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <MoneyDisplay text="Ek Garanti" value={(currentTahsilat.EkGaranti || 0).toFixed(2)} />
                    </div>
                  }
                  <Divider className={classes.dividerD} />
                  
                  {(Array.isArray(todosData) ? todosData : []).filter(d => d && d.Tip === 2 && d.Bugun === today).length > 0 &&
                    <div >
                      <TableContainer component={Paper}>
                        <Table className={classes.tableD} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Müşteri</TableCell>
                              <TableCell>FişNo</TableCell>
                              <TableCell>Tahsilat</TableCell>
                              <TableCell align="right">Tutar(TL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {todosData.filter(d => d && d.Tip === 2 && d.Bugun === today).map((rowUrun, idx) => (
                              <TableRow key={rowUrun.FisNo || idx} onClick={() => history.push(`/WorkOrder/${rowUrun.FisNo}/summary`)}>
                                <TableCell component="th" scope="row" align="left">{rowUrun.Musteri}</TableCell>
                                <TableCell>{rowUrun.FisNo}</TableCell>
                                <TableCell>{(rowUrun.TAHSILAT || "").substring(0, 5)}</TableCell>
                                <TableCell align="right">{(rowUrun.INDIRIMLI_TUTAR_KDVLI || 0).toFixed(2)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <MoneyDisplay text="Tamamlayıcı Ürün" value={(currentTahsilat.TamamlayiciUrun || 0).toFixed(2)} />
                    </div>
                  }
                </CardContent>
              </Card>
            </div>
          </div>
        </PullToRefresh>
      </Container>
    </Page>
  );
}

export default Tahsilat;